import QUESTION_TYPES from './types';
import { type IQuestion } from 'src/models';

function create(question: IQuestion) {
	return {
		type: QUESTION_TYPES.CREATE,
		payload: { question },
	};
}

function update(question: IQuestion) {
	return {
		type: QUESTION_TYPES.UPDATE,
		payload: { question },
	};
}

function remove(id: number) {
	return {
		type: QUESTION_TYPES.REMOVE,
		payload: { id },
	};
}

const questionActions = {
	create,
	update,
	remove,
};

export default questionActions;
